import { stripTrailingSlash } from 'utils/url';

const KEYCLOAK_CALLBACK_PATH = '/auth/callback';

export type KeycloakConfig = {
  issuer: string;
  clientId: string;
  redirectUri: string;
};

export type KeycloakTokenResponse = {
  access_token: string;
  refresh_token?: string;
  id_token?: string;
  token_type?: string;
  expires_in?: number;
};

export const getKeycloakConfig = (origin = window.location.origin): KeycloakConfig => ({
  issuer: process.env.KEYCLOAK_ISSUER ?? '',
  clientId: process.env.KEYCLOAK_CLIENT_ID ?? '',
  redirectUri: `${origin}${KEYCLOAK_CALLBACK_PATH}`,
});

export const getAuthorizationEndpoint = (issuer: string) => `${stripTrailingSlash(issuer)}/protocol/openid-connect/auth`;

export const getTokenEndpoint = (issuer: string) => `${stripTrailingSlash(issuer)}/protocol/openid-connect/token`;

export const getLogoutEndpoint = (issuer: string) => `${stripTrailingSlash(issuer)}/protocol/openid-connect/logout`;
